/*
$.growFade();
reduces opacity and scales an image up as you scroll. typically used with the fixed-hero plugin.
*/
(function ($) {
    $.fn.growFade = function (args) {
        if (this.length) {
            var $heroImage = $(this),
                heroHeight = $heroImage.outerHeight() + $heroImage.offset().top;

            var options = {
                opacityDivisor: 2,
                scaleDivisor: 6
            };

            $.extend(options, args);

            evo.$.window.on('scroll.scrollfade', function () {
                var $this = $(this),
                    thisScrollTop = $this.scrollTop();

                if (thisScrollTop < heroHeight) {
                    $heroImage.css({
                        opacity: 1 - ((thisScrollTop / heroHeight) / options.opacityDivisor),
                        transform: 'scale(' + (((thisScrollTop / heroHeight) / options.scaleDivisor) + 1) + ')'
                    });
                }
            });
        }
    };
})(jQuery);